import ModalComponent from "@/components/ui/modal";
import { Text, Flex, Image } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { useMedia } from "@/hooks/useMedia";
import { BXButton } from "@/styles";

const BalanceModal = ({ show, onCancel }) => {
  const { t } = useI18n();
  const { isMobile } = useMedia();

  return (
    <ModalComponent
      isShow={show}
      style={{ width: !isMobile ? "400px" : "calc(100% - 30px)" }}
    >
      <Flex
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        p={["50px 20px"]}
      >
        <Image src="../../../wwwsite/images/warning.svg" />
        <Text mt={"10px"} fontWeight={600} fontSize={"16px"}>
          {t("请先在子账户中存入资产")}
        </Text>
        <BXButton
          mt={"40px"}
          w={["100%", "200px"]}
          onClick={() => {
            onCancel && onCancel();
          }}
        >
          {t("返回")}
        </BXButton>
      </Flex>
    </ModalComponent>
  );
};

export default BalanceModal;
